export const DATE_FORMAT = "ddd DD MMM"
export const FULL_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss"
